export default {
  enabled (state) {
    return state.enabled;
  },
};
